<template>
    <div id="portfolio-header">
        <nav class="navbar">
            <span class="brand-name" @click="navigateToHome">
                <span class="brand-logo">10-4</span>
            </span>
        </nav>
    </div>
</template>

<script>
export default {
    name: 'PortfolioHeader',
    methods: {
        navigateToHome() {
            this.$router.push('/');
        }
    }
}
</script>

<style scoped>
#portfolio-header {
    background: linear-gradient(to bottom, #f5f6f7 0%, #e8eaed 100%);
    height: var(--header-height);
    display: flex;
    align-items: center;
    padding: 0 2rem;
    border-bottom: 1px solid #c2c7cc;
    box-shadow: inset 0 1px 0 #ffffff, 0 1px 3px rgba(0, 0, 0, 0.1);
}

.navbar {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.brand-name {
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: opacity 0.2s ease;
}

.brand-name:hover {
    opacity: 0.8;
}

.brand-logo {
    font-family: 'Orbitron', 'Impact', 'Arial Black', sans-serif;
    font-size: 1.8rem;
    font-weight: 900;
    background: linear-gradient(135deg, #0078d7, #1e90ff);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    letter-spacing: 0.05em;
}

@media (max-width: 768px) {
    #portfolio-header {
        padding: 0 1rem;
    }

    .brand-logo {
        font-size: 1.5rem;
    }
}

/* Windows 7 blue selection for header */
#portfolio-header ::-moz-selection {
    background-color: #0078d7;
    color: #fff;
}

#portfolio-header ::selection {
    background-color: #0078d7;
    color: #fff;
}
</style>
